import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {ResourceUnitService} from '../../../general-services/service-resources-units-anagraf/resource-unit.service';
import * as toastr from 'toastr';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-edit-resource-anagraf',
  templateUrl: './edit-resource-anagraf.component.html',
  styleUrls: ['./edit-resource-anagraf.component.scss']
})
export class EditResourceAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  resourceUnit: ResourcesUnitModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;

  idResource: number;
  nameResource: string;
  codResource: string;
  offsetResource: number;
  submitted = false;
  resourceUnitJson: any;


  constructor(private route: ActivatedRoute, private router: Router,
              private resourceUnitService: ResourceUnitService, private _Activatedroute: ActivatedRoute,
              private loaderService: LoaderService) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.resourceUnitJson = params['row'];
      });

    this.resourceUnit = new ResourcesUnitModel();
    this.formBuilder = new FormBuilder();


    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      name: [{value: '', disabled: false}, Validators.required],
      offset: [{value: '', disabled: false}]
    });

    this.resourceUnit = JSON.parse(this.resourceUnitJson) as ResourcesUnitModel;

    this.formValidator.patchValue({
      cod: this.resourceUnit ? this.resourceUnit.cod : ''
    });

    this.formValidator.patchValue({
      name: this.resourceUnit ? this.resourceUnit.name : ''
    });

    this.formValidator.patchValue({
      offset: this.resourceUnit ? this.resourceUnit.offset : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.idResource = params['id'];
      this.codResource = params['cod'];
      this.nameResource = params['name'];
      this.offsetResource = params['offset'];
    });

  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.RESOURCE_UNITS_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.resourceUnit.cod = this.formValidator.controls['cod'].value;
      this.resourceUnit.name = this.formValidator.controls['name'].value;
      this.resourceUnit.offset = this.formValidator.controls['offset'].value;
      this.saveSubscribe = this.resourceUnitService.update(this.resourceUnitService.baseUrl, this.resourceUnit).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Resource Unit Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Resource unit was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.RESOURCE_UNITS_ANAGRF]);
          }

        }, error => {
          this.loaderService.display(false);
          toastr.error('Resource unit was not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  get fv() { return this.formValidator.controls; }
}
